import React from 'react';
import Timeline from '@material-ui/lab/Timeline';
import TimelineItem from '@material-ui/lab/TimelineItem';
import TimelineSeparator from '@material-ui/lab/TimelineSeparator';
import TimelineConnector from '@material-ui/lab/TimelineConnector';
import TimelineContent from '@material-ui/lab/TimelineContent';
import TimelineDot from '@material-ui/lab/TimelineDot';
import TimelineOppositeContent from '@material-ui/lab/TimelineOppositeContent';
import Typography from '@material-ui/core/Typography';
import { dayMonthFormat, yearFormat } from '../../utils/dayjsUtils';
import { makeStyles } from '@material-ui/core/styles';
import { findHighlightEvents } from './utils';
import clsx from 'clsx';
var useStyles = makeStyles(function (theme) {
    var _a;
    return ({
        alignLeft: {},
        timelineItem: {
            '&:before': {
                display: 'none',
            },
        },
        dateText: {
            fontSize: '0.875rem',
        },
        oppositeContent: (_a = {},
            _a[theme.breakpoints.up('lg')] = {
                flex: function (props) { return "" + props.oppositeContentSpacing; },
            },
            _a),
        bold: {
            fontWeight: theme.typography.fontWeightBold,
        },
        sectionTitle: {
            marginTop: '-0.5rem',
        },
    });
});
function formatTimelineEventDates(fromDate, toDate) {
    if (!toDate) {
        return fromDate.format(dayMonthFormat);
    }
    var hasSameMonth = fromDate.month() === toDate.month();
    if (hasSameMonth) {
        return fromDate.format('D') + " - " + toDate.format('D. MMMM');
    }
    return fromDate.format('D. MMMM') + " - " + toDate.format('D. MMMM');
}
var ShowTimeline = function (_a) {
    var timelineSections = _a.timelineSections, _b = _a.oppositeContentSpacing, oppositeContentSpacing = _b === void 0 ? 0.6 : _b;
    var _c = useStyles({ oppositeContentSpacing: oppositeContentSpacing }), timelineItem = _c.timelineItem, oppositeContent = _c.oppositeContent, bold = _c.bold;
    return (React.createElement(Timeline, null, timelineSections.map(function (timelineSection, sectionIndex) {
        var isLastSection = sectionIndex + 1 === timelineSections.length;
        var eventsToHighlight = findHighlightEvents(timelineSection.events);
        return (React.createElement("div", { key: sectionIndex },
            React.createElement(TimelineItem, { className: timelineItem },
                React.createElement(TimelineOppositeContent, { className: oppositeContent },
                    React.createElement(Typography, { variant: "subtitle1" }, timelineSection.date.format(dayMonthFormat)),
                    React.createElement(Typography, { variant: "subtitle1" }, timelineSection.date.format(yearFormat))),
                React.createElement(TimelineSeparator, null,
                    React.createElement(TimelineDot, null),
                    (!isLastSection || timelineSection.events.length > 0) && React.createElement(TimelineConnector, null)),
                React.createElement(TimelineContent, null,
                    React.createElement(Typography, { variant: "subtitle1" }, timelineSection.title))),
            timelineSection.events.map(function (timelineEvent, timelineEventIndex) {
                var _a, _b, _c;
                var isLastTimelineEvent = timelineEventIndex + 1 === timelineSection.events.length;
                var shouldNotConnect = isLastSection && isLastTimelineEvent;
                var shouldHighlight = !!eventsToHighlight.find(function (highlightTimelineEvent) { return highlightTimelineEvent.id === timelineEvent.id; });
                return (React.createElement(TimelineItem, { key: timelineEventIndex, className: timelineItem },
                    React.createElement(TimelineOppositeContent, { className: oppositeContent },
                        React.createElement(React.Fragment, null,
                            React.createElement(Typography, { className: clsx((_a = {},
                                    _a[bold] = shouldHighlight,
                                    _a)), variant: "subtitle2" }, formatTimelineEventDates(timelineEvent.startDate, timelineEvent.endDate)),
                            React.createElement(Typography, { className: clsx((_b = {},
                                    _b[bold] = shouldHighlight,
                                    _b)), variant: "subtitle2" },
                                timelineEvent.startDate.format(yearFormat),
                                ' ',
                                timelineEvent.endDate && timelineEvent.startDate.year() !== timelineEvent.endDate.year()
                                    ? "- " + timelineEvent.endDate.format(yearFormat)
                                    : ''))),
                    React.createElement(TimelineSeparator, null,
                        React.createElement(TimelineDot, { variant: shouldHighlight ? 'default' : 'outlined', color: shouldHighlight ? 'primary' : 'grey' }),
                        shouldNotConnect === false && React.createElement(TimelineConnector, null)),
                    React.createElement(TimelineContent, null,
                        React.createElement(Typography, { className: clsx((_c = {},
                                _c[bold] = shouldHighlight,
                                _c)), variant: "subtitle2" }, timelineEvent.title),
                        timelineEvent.description && (React.createElement(Typography, { variant: "body2", color: "textPrimary" }, timelineEvent.description)))));
            })));
    })));
};
export { ShowTimeline };
//# sourceMappingURL=ShowTimeline.js.map